module.exports = __webpack_public_path__ + "dashboard/img/up_down.432912da803aa8c4afb84ac3d7bdfcd2.svg";